module.exports = __webpack_public_path__ + "static/media/CSharp.c368c247.png";